export const stepData = [
  {
    id: 1,
    step: 'Your Refinance Details',
    link: '/mortgage/refinance/step/primary-detail',
  },

  // {
  //   id: 1,
  //   step: 'Personal Details',
  //   link: '/mortgage/refinance/step/personal-detail',
  // },
  // {
  //   id: 2,
  //   step: 'Property Details',
  //   link: '/mortgage/refinance/step/property-detail',
  // },
  {
    id: 3,
    step: 'Income Details',
    link: '/mortgage/refinance/step/income-detail',
  },
];
